'use client';

import * as React from 'react';
import { useAppSelector } from '@/store/hooks';
import { getDrawerContent } from '@/store/reducers/drawer-content-slice';
import { CircularProgress } from '@mui/material';
import { Box, Stack } from '@mui/system';

import { PlayerActionsTable } from './player-actions-table';

export function PlayerActionsTab(): React.JSX.Element {
  const { PLAYER_DETAILS: data } = useAppSelector(getDrawerContent);

  return (
    <Stack direction="column">
      {!data ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', p: 6 }}>
          <CircularProgress color="primary" size={38} />
        </Box>
      ) : (
        <Stack gap={2}>
          <PlayerActionsTable playerData={data} />
        </Stack>
      )}
    </Stack>
  );
}
